<template>
  <div class="rt-lookup" @keyup.delete="deletevalue">
    <el-input readonly :disabled="disabled" icon="search" v-model="lookupValue.name" :on-icon-click="showLookupDialog">
    </el-input>
    <rt-lookup-dialog ref="lookupDialog" :isMaskShow="isMaskShow" :entity="entity" v-bind:condition="condition" :request-url="dialogRequestUrl" :name-field="nameField" :id-field="idField" :display-fields="dialogDisplayFields" :orderby-fields="dialogOrderbyFields" :filter-fields="dialogFilterFields" @data-selected="handleDataSelected"></rt-lookup-dialog>
  </div>

</template>

<script>
import RtLookupDialog from "./lookup-dialog";

export default {
  name: "RtLookup",
  props: {
    isMaskShow:{
      type:Boolean,
      default:()=>true,
      required:false
    },
    value: {
      type: Object|String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    entity: {
      type: String,
      required: true
    },
    condition: String,
    nameField: String,
    idField: String,
    dialogRequestUrl: String,
    dialogDisplayFields: Array,
    dialogOrderbyFields: String,
    dialogFilterFields: String,
    disa: false
  },
  components: {
    "rt-lookup-dialog": RtLookupDialog
  },
  computed: {
    setDisabled: function() {
      if (!this.lookupValue && this.disabled) {
        this.disa = true;
      }
    }
  },
  data() {
    return {
      lookupValue: {}
    };
  },

  rules: {},
  methods: {
    //退格以删除lookup
    deletevalue() {
      if (!this.disabled) {
        this.lookupValue = {};
        this.$emit("input", this.lookupValue);
      }
    },
    showLookupDialog() {
      if (this.disabled) {
        return;
      }
      this.$refs.lookupDialog.show();
    },
    handleDataSelected(val) {
      this.lookupValue = val;
      this.$emit("input", val);
    }
  },
  watch: {
    value: {
      handler(newValue){
        this.lookupValue = newValue || {};
      },
      immediate: true
    },

    methods: {
      showLookupDialog() {
        this.$refs.lookupDialog.show();
      },
      handleDataSelected(val) {
        this.lookupValue = val;
        this.$emit("input", val);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// lookup.vue?509df860